import { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { useLocation } from '@remix-run/react';

interface PageTransitionProps {
  children: ReactNode;
}

export const PageTransition = ({ children }: PageTransitionProps) => {
  const location = useLocation();

  return (
    <motion.div
      key={location.pathname}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        type: 'spring',
        stiffness: 400,
        damping: 40,
        mass: 1,
      }}
      style={{ height: '100%' }}
    >
      {children}
    </motion.div>
  );
};
